/**
 * @file 获取资源列表
 * @author liudy
 */

import Api from '../../../path'
import { BusinessObjectIdType, ResourceType } from '@umu/umu-types';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

export interface IBindResourceInput {
    parent_id: string;
    parent_type: BusinessObjectIdType;
    bind_resource_ids: string;
    unbind_resource_ids: string;
    resource_type: ResourceType;
}

export interface IBindResourceOutput {
    bind_ret: { [propName: string]: number };
    unbind_ret: { [propName: string]: number };
}

export const bindResource = fetchDataSync((data: IBindResourceInput): Promise<IResponse<IBindResourceOutput>> => {
    return fetchData(Api.RESOURCE_BIND_UPD, data).then((res: IResponse<IBindResourceOutput>) => {
        return res;
    });
});
